import { Offer, SDKConfig, WebhookResponse } from '../types';
import { DEFAULT_BASE_URL } from '../utils/api';
import { AuthManager } from './auth';

export class OfferManager {
  private apiKey: string;
  private baseURL: string;
  private authManager: AuthManager;

  constructor(config: SDKConfig) {
    this.apiKey = config.apiKey;
    this.baseURL = config.baseURL || DEFAULT_BASE_URL;
    this.authManager = new AuthManager(config);
  }

  public isWebAppAvailable(): boolean {
    return typeof window !== 'undefined' && 
           window.Telegram !== undefined && 
           window.Telegram.WebApp !== undefined;
  }

  public getTelegramUserId(): string | null {
    if (!this.isWebAppAvailable()) {
      return null;
    }
    return window.Telegram?.WebApp?.initDataUnsafe?.user?.id || null;
  }

  
  async markActionComplete(advertiserId: string, idToken: string,autoClose: boolean = false): Promise<any[]> {
    try {
      const token = await this.authManager.getValidToken();

      let telegram_user_id = null;
      const result = await fetch(`${this.baseURL}/advertiser/completionRewardWebhook`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          advertiserId,
          idToken:idToken
        })
      });
      const responseText = await result.text();

      const response = JSON.parse(responseText) as WebhookResponse;

      // Update success check based on API response
      if (response.status !== 200) {
        // throw new Error(response.message || 'Failed to send rewards');
      }
      if(autoClose){
        setTimeout(() => {
            //auto close current window tab and navigate to previous history link
            window.close();
            // window.history.back();
        },1000)
      }
      return response.results;
    } catch (error) {
      throw new Error(`Failed to send rewards: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}